export default "__VITE_ASSET__CXq2DL0k__"